import angular from 'angular';
import dompurify from 'dompurify';

angular
  .module('cxSettings')
  .controller('EditTaskTemplateDocumentationCtrl', [
    '$element',
    '$scope',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'taskTemplate',
    editTaskTemplateDocumentationCtrl,
  ]);

function editTaskTemplateDocumentationCtrl(
  $element,
  $scope,
  $http,
  appUrls,
  flySvc,
  close,
  taskTemplate,
) {
  var vm = this;
  vm.showValidation = false;
  vm.taskTemplate = taskTemplate;
  vm.documentation = null;

  $http.get(`${appUrls.tasks}/api/tasktemplates/documentation/${taskTemplate.id}`).then(
    function({ data }) {
      vm.documentation = data;
    },
    error => flySvc.error(error),
  );

  vm.setDocumentation = () => {
    const documentation = vm.isDocumentationEmpty(vm.documentation) ? null : vm.documentation;
    $http.put(`${appUrls.tasks}/api/tasktemplates/${taskTemplate.id}/documentation`, {
      documentation,
    });
  };

  vm.isDocumentationEmpty = documentation => {
    // Small hack to render document in hidden div, and then retrieve text content
    // seemed more useful than regex replace. The inner content of the ckEditor always
    // contains some high-level HTML tags without content, so a simple 'empty' check
    // on the string value isn't sufficient.
    const div = document.createElement('div');
    div.innerHTML = dompurify.sanitize(documentation);
    return !div.textContent.trim();
  };

  vm.save = function() {
    if ($scope.form.$invalid) return;
    vm.saving = true;

    let model = angular.copy(taskTemplate);

    delete model.assignedTo;
    delete model.mailTemplate;
    delete model.tags;
    vm.setDocumentation();

    $http.put(appUrls.tasks + '/api/tasktemplates/templates', model).then(
      function({ data = {} }) {
        vm.saving = false;
        $element.modal('hide');
        close(data, 500);
        flySvc.success();

        taskTemplate.documentation = vm.documentation;

        return false;
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
      },
    );
  };

  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
